var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{class:{
    'heading-card--bold': _vm.bold,
    'heading-card--dark-blue': _vm.color == 'dark-blue',
    'heading-card--soft-blue': _vm.color == 'soft-blue',
  }},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }